"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePreviousCompare;
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _react = require("react");
// Hook that uses previous value when new value is equal based on provided compare function
// Useful when object reference changes, but actual data remains the same
function usePreviousCompare(next) {
  var compare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _isEqual.default;
  var ref = (0, _react.useRef)();
  var prev = ref.current;
  var areEqual = compare(prev, next);
  (0, _react.useEffect)(function () {
    if (!areEqual) {
      ref.current = next;
    }
  }, [next, areEqual]);
  return areEqual ? prev : next;
}